import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ScreenRecorderComponent } from './screen-recorder.component';
import { VideoRecordingService } from './screen-recorder.service';
import { SharedModule } from '../shared-module/shared-module.module';
import { FormsModule } from '@angular/forms';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';






@NgModule({
  declarations: [ScreenRecorderComponent],
  imports: [
    BrowserModule,
    FormsModule,
    NzRadioModule,
    NzButtonModule,
    NzIconModule,
    NzDividerModule,
    NzProgressModule,
    NzToolTipModule,
    SharedModule
  ],
  providers:[VideoRecordingService],
  exports:[
    ScreenRecorderComponent
  ]
})
export class ScreenRecorderModule { }
